export const CONSENT_ACTION_ACCEPT = 'accept';
export const CONSENT_ACTION_REVOKE = 'revoke';

export const CHAT_SUGGESTION_CONSENT_ACCEPTED = 'accepted';
export const CHAT_SUGGESTION_CONSENT_NOT_ACCEPTED = 'not_accepted';
export const MESSAGE_SUGGESTIONS_CONSENT = 'message_suggestions_consent';

export const SOURCE_SESSION_EVENT_MATCHLIST = 'matchlist';
export const SOURCE_SESSION_EVENT_CHAT = 'chat';
